import
  React
from 'react';

import {
  PropTypes
} from 'prop-types';

import {
  TileCard
} from '@vodacom/web-common';

import {
  FeedProvider
} from '../providers';

export const Base64ImageCard = props => {

  const [
    state,
    setState
  ] = React.useState({
    base64Image: ''
  });

  React.useEffect(() => {

    let isMounted = true;

    const getFeedImage = async (
      imageId,
      feedName,
      feedCategory
    ) => {

      if (!imageId || !feedName || feedName === 'News24') {
        return;
      }

      const base64Image = await FeedProvider.getFeedImage(imageId, feedName, feedCategory);

      if (!base64Image?.ok || !base64Image.result || !isMounted) {
        return;
      }

      setState(prevState => ({
        ...prevState,
        base64Image: base64Image.result
      }));

      if (!base64Image?.ok || !base64Image.result || !isMounted) {
        return;
      }

      setState(prevState => ({
        ...prevState,
        base64Image: base64Image.result
      }));
    };

    getFeedImage(props.imageId, props.feedName, props.feedCategory);

    return () => {
      isMounted = false;
    };

  }, [ props.imageId, props.feedName ]);

  return (

    <TileCard
      title={props.title}
      text={props.text}
      image={state.base64Image ? `data:image/png;base64,${state.base64Image}` : props.defaultImage}
      imageHeight={props.imageHeight}
      imageObjectFit={props.imageObjectFit}
      buttonMinWidth={'92%'}
      buttonText={props.buttonText}
      cardMargin={'0px'}
      subtitle={props.subtitle}
      buttonActiveOpacity={'0.25'}
      onClick={props.onClick} />
  );
};

Base64ImageCard.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  imageHeight: PropTypes.string,
  imageObjectFit: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  defaultImage: PropTypes.string,
  imageId: PropTypes.string,
  feedName: PropTypes.string,
  feedCategory: PropTypes.string
};

Base64ImageCard.defaultProps = {
  title: '',
  text: '',
  imageHeight: 'auto',
  imageObjectFit: 'fill',
  buttonText: '',
  subtitle: '',
  onClick: () => {},
  defaultImage: '',
  imageId: '',
  feedName: '',
  feedCategory: ''
};